// extracted by mini-css-extract-plugin
module.exports = {"myBag":"Styles_myBag__cSSCu","icon":"Styles_icon__2Kw8b"};